import React from "react";
import PropTypes from "prop-types";
import createReactClass from "create-react-class";

// import CapacityBar from './capacity_bar'
import PhotoViewAlbumInfo from "./photo_view_album_info";
import AlbumPhotoList from "./album_photo_list";

export default createReactClass({
  displayName: "Root",
  propTypes: {
    album: PropTypes.object.isRequired,
    publicTypeData: PropTypes.object.isRequired,
    memberId: PropTypes.number.isRequired,
    photoStrageLimit: PropTypes.number.isRequired,
    chargePlanType: PropTypes.number.isRequired,
    isCirclePrivate: PropTypes.bool.isRequired,
    myMemberType: PropTypes.number.isRequired,
  },
  getInitialState() {
    return {
      allFileCapacity: 0,
      albumFileCapacity: 0,
      canUploadPrivatePhoto: true,
      // 写真の枚数（読み込み前は null）。見出しの「⋮」と「編集」の出し分けにだけ使う
      photoCount: null,
    };
  },
  componentDidMount() {
    // this.loadAllFileCapacityFromServer();
    // if (this.props.album.public_type == 2) {
    //   this.loadAlbumFileCapacityFromServer();
    // }
  },
  loadAlbumFileCapacityFromServer() {
    // if (this.props.chargePlanType != 0) {
    //   return;
    // }
    // $.ajax({
    //   url: '/api/album/get_album_file_capacity',
    //   type : 'POST',
    //   data: {
    //     album_id: this.props.album.id
    //   },
    //   cache: false,
    //   success: function(data) {
    //     var capacity = Number(data);
    //     this.setState({
    //       albumFileCapacity: capacity,
    //     });
    //   }.bind(this),
    //   error: function(xhr, status, err) {
    //   }.bind(this)
    // });
  },
  loadAllFileCapacityFromServer() {
    // if (this.props.chargePlanType != 0) {
    //   return;
    // }
    // $.ajax({
    //   url: '/api/album/get_all_file_capacity',
    //   type : 'POST',
    //   data: {
    //     circle_id: this.props.album.circle_id
    //   },
    //   cache: false,
    //   success: function(data) {
    //     var capacity = Number(data);
    //     var flg = capacity < this.props.photoStrageLimit;
    //     this.setState({
    //       allFileCapacity: capacity,
    //       canUploadPrivatePhoto: flg
    //     });
    //   }.bind(this),
    //   error: function(xhr, status, err) {
    //   }.bind(this)
    // });
  },
  render() {
    // var capacityBar = '';
    // if(this.props.chargePlanType == 0) {
    //   capacityBar = <CapacityBar
    //     allFileCapacity = {this.state.allFileCapacity}
    //     albumFileCapacity = {this.state.albumFileCapacity}
    //     photoStrageLimit = {this.props.photoStrageLimit}
    //   />;
    // }
    return (
      <div
        className="album container overflow-hidden"
        style={{ width: "100%", margin: "0 auto" }}
      >
        {/* {capacityBar} */}
        <PhotoViewAlbumInfo
          album={this.props.album}
          circleName={this.props.circleName}
          publicTypeData={this.props.publicTypeData}
          isEditMode={this.state.isEditMode}
          changeEditMode={this.changeEditMode}
          photoStrageLimit={this.props.photoStrageLimit}
          allFileCapacity={this.state.allFileCapacity}
          albumFileCapacity={this.state.albumFileCapacity}
          chargePlanType={this.props.chargePlanType}
          isCirclePrivate={this.props.isCirclePrivate}
          myMemberType={this.props.myMemberType}
          photoCount={this.state.photoCount}
          // 見出しの「⋮」から、写真の並びの削除の切り替えを呼ぶためのつなぎ（見た目のみ）
          changePhotoDeleteMode={() =>
            this.albumPhotoList && this.albumPhotoList.changeDeleteMode()
          }
          getPhotoState={() =>
            this.albumPhotoList
              ? {
                  count: this.albumPhotoList.state.photoList.photos.length,
                  isDeleteMode: this.albumPhotoList.state.isDeleteMode,
                }
              : { count: 0, isDeleteMode: false }
          }
        />
        <AlbumPhotoList
          ref={(c) => {
            this.albumPhotoList = c;
          }}
          onPhotoCountChange={(count) => this.setState({ photoCount: count })}
          album={this.props.album}
          memberId={this.props.memberId}
          loadAllFileCapacityFromServer={this.loadAllFileCapacityFromServer}
          loadAlbumFileCapacityFromServer={this.loadAlbumFileCapacityFromServer}
          canUploadPrivateStrage={this.state.canUploadPrivatePhoto}
          myMemberType={this.props.myMemberType}
        />
      </div>
    );
  },
});
